module.exports = __webpack_public_path__ + "img/webchat.a55997ad.png";